<script setup lang="ts">
import { cn } from '@ui/lib/utils.js';
import { Primitive, type PrimitiveProps } from 'reka-ui';
import { type PButtonSize, type PButtonVariant, pButtonVariants } from './index.js';
import type { HTMLAttributes } from 'vue';

export interface PButtonProps extends PrimitiveProps {
    variant?: PButtonVariant;
    size?: PButtonSize;
    rounded?: boolean;
    class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<PButtonProps>(), {
    as: 'button',
});
</script>

<template>
    <Primitive
        data-slot="button"
        :as="as"
        :as-child="asChild"
        :class="cn(pButtonVariants({ variant, size }), props.class, { 'rounded-full': rounded })"
    >
        <slot />
    </Primitive>
</template>
